import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'DashboardMain' },
    name: 'Index',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/dashboard',
    redirect: { name: 'DashboardMain' },
    name: 'Dashboard',
    meta: {
      requiresAuth: true,
    },
    component: () => import(/* webpackChunkName: "EditMainScreen" */ '../views/EditMainScreen/EditMainScreen.vue'),
    children: [
      {
        path: '/',
        name: 'DashboardMain',
        component: () => import(/* webpackChunkName: "DashboardMain" */ '../views/DashboardMain.vue'),
      },
      {
        path: 'kegManage',
        name: 'KegManage',
        component: () => import(/* webpackChunkName: "KegManage" */ '../views/Keg/KegIndex.vue'),
      },
      {
        path: 'kegBatchIndex',
        name: 'kegBatchIndex',
        component: () => import(/* webpackChunkName: "kegBatchIndex" */ '../views/Keg/KegBatchIndex.vue'),
      },
      {
        path: 'kegBatchRent',
        name: 'kegBatchRent',
        component: () => import(/* webpackChunkName: "kegBatchRent" */ '../views/Keg/batchs/BatchRent.vue'),
      },
      {
        path: 'kegBatchReturn',
        name: 'kegBatchReturn',
        component: () => import(/* webpackChunkName: "kegBatchReturn" */ '../views/Keg/batchs/BatchReturn.vue'),
      },
      {
        path: 'kegBatchWash',
        name: 'kegBatchWash',
        component: () => import(/* webpackChunkName: "kegBatchWash" */ '../views/Keg/batchs/BatchWash.vue'),
      },
      {
        path: 'kegBatchFill',
        name: 'kegBatchFill',
        component: () => import(/* webpackChunkName: "kegBatchFill" */ '../views/Keg/batchs/BatchFill.vue'),
      },
      {
        path: 'kegBatchWashAndFill',
        name: 'kegBatchWashAndFill',
        component: () => import(/* webpackChunkName: "kegBatchWashAndFill" */ '../views/Keg/batchs/BatchWashAndFill.vue'),
      },
      {
        path: 'kegSearchQuery',
        name: 'kegSearchQuery',
        component: () => import(/* webpackChunkName: "kegSearchQuery" */ '../views/Keg/batchs/SearchQuery.vue'),
      },
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// Navigation Guard
router.beforeEach(async(to, from, next) => {
  
  console.log(`From ${from.name} to ${to.name}`);
  console.log(`requiresAuth: ` +  to.matched.some((record) => record.meta.requiresAuth))
  console.log(store.getters['auth/hasToken'])
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['auth/hasToken']) {
      next();
    } else if(store.getters['auth/hasCookie']) {
      try {
        await store.dispatch('auth/initLoginToken');
        next();
      } catch (error) {
        console.error(error);
        next({ name: 'Login' });
      }
    } else {
      next({ name: 'Login' });
    }
  } else {
    next();
  }
});

// router.beforeEach( (to, from, next) => {
//   console.log(`From ${from.name} to ${to.name}`);
//   console.log(`requiresAuth: ` +  to.matched.some((record) => record.meta.requiresAuth))
//   console.log(store.getters['auth/hasToken'])
//   next();
// })


router.afterEach(() => {
  store.dispatch('setMobileSideBarShow', false);
});
export default router
